'use client';

import React from 'react';
import { Button, Modal } from 'react-bootstrap';

import {useTranslations} from 'next-intl';
import useStore from '@store/index';

import styles from './opening-hours.module.scss';
import menustyles from '@/styles/menu.module.scss';
import { timezoneDateConvert } from '_services/common.service';
import { event } from '@lib/ga';

// import { checkCompanyOpened } from '../../_services/common.service';

export const OpeningHoursModal = (
  {
    isCompanyOpen,
    currentDate
  }: {
    isCompanyOpen: boolean | null,
    currentDate: Date | null
  }
) => {
  const [showOpeningHours, setShowOpeningHours] = React.useState(false);

  const t = useTranslations("OpeningHoursModal");
  const { companyDetails } = useStore((state) => state);

  const { openingHours } = companyDetails?.additionalInfo || {};

  const weekdaysOrder = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
  
  const getCurrentDay = () => {
    const serverTime = (currentDate || new Date());

    const today = serverTime.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase().substring(0, 3);
    return today;
  };

  /* const formatTime = (time: string) => {
    const [hours, minutes] = time.split(':');
    const date = new Date();
    date.setHours(parseInt(hours), parseInt(minutes));
    return date.toLocaleTimeString('en-US', { 
      hour: 'numeric',
      minute: '2-digit',
      hour12: true 
    });
  }; */

  // console.log(openingHours);
  

  return (<>
    {isCompanyOpen !== null && <div
      className={`${menustyles.status} ${isCompanyOpen ? menustyles.open : menustyles.closed}`}
      onClick={() => {
        setShowOpeningHours(true);
      
        event({
          action: 'open_opening_hours_modal',
          category: 'engagement',
          label: 'opening_hours_modal_opened'
        });
      }}
    >
      {isCompanyOpen ? t('OPEN') : t('CLOSED')}
    </div>}

    <Modal 
      show={showOpeningHours} 
      onHide={() => setShowOpeningHours(false)}
      className={styles.modal}
      dialogClassName={styles.dialog}
    >
      {/* <div className={styles.handle} /> */}
      
      <Modal.Body className={styles.modalBody}>
        <h2>{t('OPENING_HOURS')}</h2>

        <div className={styles.hoursList}>
          {weekdaysOrder.map((weekday, weekindex) => {
            const day = (openingHours || []).find((d) => d.day.toLowerCase() === weekday.toLowerCase());

            return(
            <div 
              key={weekindex}
              className={`${styles.dayRow} ${(!day ? styles.dayClosed : '')} ${isCompanyOpen ? styles.open : styles.closed} ${getCurrentDay() === (day?.day || weekday).toLowerCase() ? styles.today : ''}`}
            > 
              <span className={styles.dayName}>
                {t("WEEKDAYS." + ((day?.day || weekday) as string).toUpperCase())}
                {getCurrentDay() === (day?.day || weekday).toLowerCase() && <span className={styles.todayBadge}>{t('TODAY')}</span>}
              </span>
              <div className={styles.dayHours}>
                {/* {!day && <span className={styles.closed}>{t('CLOSED')}</span>} */}

                {day && day.isOpen? <>
                  {(day?.openingHours || []).map((hour, index) => (
                    <div key={index} className={styles.hoursContainer}>
                      <span className={`${styles.hours}`}>
                        {timezoneDateConvert({ utcDate: (hour.startTime || ''), timezone: (companyDetails?.timeZone || ''), format: 'hh:mm A' })}
                      </span>
                      <span className={styles.separator}> - </span>
                      <span className={`${styles.hours}`}>
                        {timezoneDateConvert({ utcDate: (hour.endTime || ''), timezone: (companyDetails?.timeZone || ''), format: 'hh:mm A' })}
                      </span>
                    </div>
                  ))}
                </>: <span className={styles.closed}>{t('SHOP_CLOSED')}</span>}
              </div>
            </div>)
          })}
        </div>
      </Modal.Body>
      <Modal.Footer>
          <Button id="nav-opening-hours-close-button" className={`${styles.button} ${styles.primary}`} onClick={() => setShowOpeningHours(false)}>
              {t('CLOSE')}
          </Button>
      </Modal.Footer>
    </Modal>
  </>);
};

export default OpeningHoursModal;
